import React from 'react';
import SafetyPointsAnnualPage from './SafetyPointsAnnualPage';
import { useAuth } from '../../context/AuthContext';

// 独立入口包装：从全局 auth 中获取权限数组（AuthContext 会在启动时用 /me 刷新权限）
const SafetyPointsPage = () => {
  const auth = useAuth();
  const perms = Array.isArray(auth?.user?.permissions) ? auth.user.permissions : [];
  return <SafetyPointsAnnualPage permissions={perms} />;
};

export default SafetyPointsPage;
